import { useMediaQuery } from '@mantine/hooks'
import { Typography } from '../../common/typography'
import { useParams } from 'react-router'
import classes from './TeamComponents.module.css'
import { useTeamRaceStats } from '../../races/api'
import RacesPerformanceOverview from '../../stories/PerformanceOverview/RacesPerformanceOverview'
import RaceSummary from '../../stories/RaceSummary/RaceSummary'

export default function TeamRaces() {
  const isDesktop = useMediaQuery('(min-width: 800px)')
  const { competitionId, teamId } = useParams()

  const { data: team_race_stats } = useTeamRaceStats({
    competition_id: Number(competitionId),
    team_id: Number(teamId),
  })

  return (
    <div className={classes.teamMatchesContainer}>
      {isDesktop && (
        <Typography
          level={3}
          fs="xl"
          fw={500}
          fc={{ light: 'black', dark: 'gray-3' }}
          lh="100"
          tt="capitalize"
        >
          Season story: team performance overview
        </Typography>
      )}
      <div className={classes.teamMatchesWrapper}>
        <div className={classes.performanceOverviewWrapper}>
          <RacesPerformanceOverview
            stats={team_race_stats.season_stats}
            title={
              isDesktop ? undefined : 'Season story: team performance overview'
            }
          />
        </div>
      </div>
      <RaceSummary
        teamId={parseInt(teamId || '0', 10)}
        competitionId={parseInt(competitionId || '0', 10)}
        summary_title="Race Form Summary"
        isDesktop={isDesktop}
      />
    </div>
  )
}
